import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { segmentAutocompleteGet } from "../../../../services/procurement/procurementAPIs";
import alertDispatcher from "../../../../utils/alertsUtils";
import { COST_CENTRE_INPUT_PLACEHOLDER, COST_CENTRE_LABEL } from "../labels";
import SearchAsYouType from "../searchAsYouType";

const CostCentreSearchAsYouType = ({
    disabled,
    selectedValue,
    setSelectedValue,
}) => {
    const dispatch = useDispatch();

    const autocompleteGet = (searchTerm, setOptions, setIsLoading) => {
        let newOptions = [];

        // If an input is selected, set it as the option
        if (selectedValue) {
            newOptions = [selectedValue];
        }

        setIsLoading(true);

        segmentAutocompleteGet(2, searchTerm)
            .then((results) => {
                if (results) {
                    newOptions = [...newOptions, ...results];
                }
                setOptions(newOptions);
            })
            .catch((error) => {
                alertDispatcher(
                    "costCentreAutocompleteGet",
                    error?.response?.status,
                    dispatch
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <SearchAsYouType
            selectedValue={selectedValue}
            onSelectValue={setSelectedValue}
            isDisabled={disabled}
            autocompleteGet={autocompleteGet}
            searchPrompt={COST_CENTRE_INPUT_PLACEHOLDER}
            label={COST_CENTRE_LABEL}
            optionKeyMapping={{
                id: "SEGMENT2_ID",
                label: "SEGMENT2_NAME",
            }}
        />
    );
};

CostCentreSearchAsYouType.propTypes = {
    disabled: PropTypes.bool,
    selectedValue: PropTypes.object,
    setSelectedValue: PropTypes.func.isRequired,
};

export default CostCentreSearchAsYouType;
